const infoReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_INFO_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                error: false,
                errorMessage: null,
                resource: action.data.resource
            });
        case 'DONE_GET_INFO_RESOURCE':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_INFO_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_INFO_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: false,
                errorMessage: null,
                resource: null,
            });
        default:
            return state;
    }
};

export default infoReducer;
